import React from "react";
import { getTranslation } from "../TranslationWrapper/TranslationWrapper";
import * as actions from "../../store/actions";
import { connect } from "react-redux";
import AsynchronousAutocomplete from "../Autocomplete/AsynchronousAutocomplete";

function VenueFilter(props) {
  return (
    <AsynchronousAutocomplete
      async={{
        url: "core/venue/search?fields=id as value, name as label&per_page=10",
        searchField: "name",
      }}
      onChange={(e, option) => {
        if (option) {
          props.setFilter("venue_id", {
            field: "venue_id",
            operator: "=",
            value: option.value,
            label: option.label,
          });
          props.setFilter("vestiging.venue_id", {
            field: "vestiging.venue_id",
            operator: "=",
            value: option.value,
            label: option.label,
          });
        } else {
          props.setFilter("venue_id", null);
          props.setFilter("vestiging.venue_id", null);
        }
      }}
      placeholder={getTranslation("Filter on venue")}
      value={props.filters.venue_id}
    />
  );
}

const mapStateToProps = (state) => {
  let filters = {};
  if (state.filtersV2["venue_id"]) {
    filters["venue_id"] = state.filtersV2["venue_id"];
  }
  return { filters };
};

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, filter) => {
    dispatch({
      type: actions.SET_FILTER,
      payload: { key, filter },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(VenueFilter);
